import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class PaymentService {

  abstract url: string;

  constructor(
    private appService: AppService
  ) { }

  /*
  * Step 3A-1
  * 取得活期帳戶銀行列表、保費以及投保日
  * */
  getBankListAndPremiumsInfo(): Observable<any> {
    return this.appService.postRequest(this.url, { action: 'getBankListAndPremiumsInfo' });
  }

  /*
  * Step 3A-2
  * 提交活期帳戶付款資訊
  * */
  debitFromAccount(insurancePayBank: string, insurancePayAccount: string): Observable<any> {
    return this.appService.postRequest(this.url,
      { action: 'debitFromAccount', bankSelected: insurancePayBank, accountNum: insurancePayAccount });
  }

  /************************************** 活期帳戶付款 | 信用卡付款 **************************************/

  /*
  * Step 3B-1
  * 同意首續期保費自動依信用卡付款條款
  * */
  applyAutoBillchnl(autoBillchnl): Observable<any> {
    return this.appService.postRequest(this.url, { action: 'applyAutoBillchnl', auto_billchnl: autoBillchnl });
  }

  /*
  * Step 3B-2
  * 取得信用卡交易網址
  * */
  getNccKeyAndUrl(): Observable<any> {
    return this.appService.postRequest(this.url, { action: 'getNccKeyAndUrl', refresh: 'true' });
  }

  /*
  * Step 3B-3
  * 需要3D驗證 ? 取得3D驗證html : 進行完成步驟(略過最後步驟)
  * */
  checkCardBindingResult(): Observable<any> {
    return this.appService.postRequest(this.url, { action: 'checkCardBindingResult' });
  }

  /*
  * Step 3B-4
  * 取得信用卡繳費狀態(完成/失敗)
  * */
  checkCardDebitResult(): Observable<any> {
    return this.appService.postRequest(this.url, { action: 'checkCardDebitResult' });
  }

}
